import { useDispatch, useSelector } from 'react-redux';
import { toggleGlobalLoading } from '../../redux/actions/app';
import { globalLoadingSelector } from '../../redux/selectors/app';
import { IGlobalLoader } from '../../types/redux/app';

const useGlobalLoader = () => {
    const dispatch = useDispatch();
    const loaders = useSelector(globalLoadingSelector);

    const toggleLoader = (data: IGlobalLoader) => {
        dispatch(toggleGlobalLoading(data));
    };

    return {
        loaders,
        toggleLoader,
    };
};

export default useGlobalLoader;
